var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-reg-flow',{attrs:{"instance":_vm.instance,"name":"reg-flow","dangerously-disable-security-checks":false}})}
var staticRenderFns = []

export { render, staticRenderFns }